export const LOAD_WIZARD_STATE = 'wizard/LOAD_WIZARD_STATE';
export const LOAD_WIZARD_STATE_SUCCESS = 'wizard/LOAD_WIZARD_STATE_SUCCESS';
export const LOAD_WIZARD_STATE_FAILURE = 'wizard/LOAD_WIZARD_STATE_FAILURE';

export const INIT_WIZARD = 'wizard/INIT_WIZARD';
export const INIT_WIZARD_SUCCESS = 'wizard/INIT_WIZARD_SUCCESS';
export const INIT_WIZARD_FAILURE = 'wizard/INIT_WIZARD_FAILURE';

export const UPDATE_WIZARD_STEP = 'wizard/UPDATE_WIZARD_STEP';
export const UPDATE_WIZARD_STEP_SUCCESS = 'wizard/UPDATE_WIZARD_STEP_SUCCESS';
export const UPDATE_WIZARD_STEP_FAILURE = 'wizard/UPDATE_WIZARD_STEP_FAILURE';

export const SET_CURRENT_STEP = 'wizard/SET_CURRENT_STEP';
export const SET_CURRENT_STEP_SUCCESS = 'wizard/SET_CURRENT_STEP_SUCCESS';
export const SET_CURRENT_STEP_FAILURE = 'wizard/SET_CURRENT_STEP_FAILURE';

export const COMPLETE_WIZARD = 'wizard/COMPLETE_WIZARD';
export const COMPLETE_WIZARD_SUCCESS = 'wizard/COMPLETE_WIZARD_SUCCESS';
export const COMPLETE_WIZARD_FAILURE = 'wizard/COMPLETE_WIZARD_FAILURE';

export const RESET_WIZARD = 'wizard/RESET_WIZARD';
export const RESET_WIZARD_SUCCESS = 'wizard/RESET_WIZARD_SUCCESS';
export const RESET_WIZARD_FAILURE = 'wizard/RESET_WIZARD_FAILURE';

export const CLEAR_WIZARD_ERROR = 'wizard/CLEAR_WIZARD_ERROR';

export const loadWizardState = (shopId, wizardType = 'integration-wizard-v2') => ({
  type: LOAD_WIZARD_STATE,
  payload: { shopId, wizardType },
});

export const initWizard = (shopId, wizardType = 'integration-wizard-v2', initialData = {}) => ({
  type: INIT_WIZARD,
  payload: { shopId, wizardType, initialData },
});

export const updateWizardStep = (shopId, wizardType = 'integration-wizard-v2', stepId, stepIndex, stepData) => ({
  type: UPDATE_WIZARD_STEP,
  payload: { shopId, wizardType, stepId, stepIndex, stepData },
});

export const setCurrentStep = (shopId, wizardType = 'integration-wizard-v2', stepIndex) => ({
  type: SET_CURRENT_STEP,
  payload: { shopId, wizardType, stepIndex },
});

export const completeWizard = (shopId, wizardType = 'integration-wizard-v2') => ({
  type: COMPLETE_WIZARD,
  payload: { shopId, wizardType },
});

export const resetWizard = (shopId, wizardType = 'integration-wizard-v2') => ({
  type: RESET_WIZARD,
  payload: { shopId, wizardType },
});

export const clearWizardError = () => ({
  type: CLEAR_WIZARD_ERROR,
});

const initialWizardState = {
  state: null,
  loading: false,
  saving: false,
  error: null,
};

const initialState = {
  wizards: {},
};

const wizardReducer = (state = initialState, action) => {
  const wizardType = action.payload?.wizardType;

  switch (action.type) {
    case LOAD_WIZARD_STATE:
    case INIT_WIZARD:
      return {
        ...state,
        wizards: {
          ...state.wizards,
          [wizardType]: {
            ...(state.wizards[wizardType] || initialWizardState),
            loading: true,
            error: null,
          },
        },
      };

    case LOAD_WIZARD_STATE_SUCCESS:
    case INIT_WIZARD_SUCCESS:
    case UPDATE_WIZARD_STEP_SUCCESS:
    case SET_CURRENT_STEP_SUCCESS:
    case COMPLETE_WIZARD_SUCCESS:
      return {
        ...state,
        wizards: {
          ...state.wizards,
          [wizardType]: {
            state: action.payload.wizardState,
            loading: false,
            saving: false,
            error: null,
          },
        },
      };

    case LOAD_WIZARD_STATE_FAILURE:
    case INIT_WIZARD_FAILURE:
      return {
        ...state,
        wizards: {
          ...state.wizards,
          [wizardType]: {
            ...(state.wizards[wizardType] || initialWizardState),
            loading: false,
            error: action.payload.error,
          },
        },
      };

    case UPDATE_WIZARD_STEP:
    case SET_CURRENT_STEP:
    case COMPLETE_WIZARD:
    case RESET_WIZARD:
      return {
        ...state,
        wizards: {
          ...state.wizards,
          [wizardType]: {
            ...(state.wizards[wizardType] || initialWizardState),
            saving: true,
            error: null,
          },
        },
      };

    case UPDATE_WIZARD_STEP_FAILURE:
    case SET_CURRENT_STEP_FAILURE:
    case COMPLETE_WIZARD_FAILURE:
    case RESET_WIZARD_FAILURE:
      return {
        ...state,
        wizards: {
          ...state.wizards,
          [wizardType]: {
            ...(state.wizards[wizardType] || initialWizardState),
            saving: false,
            error: action.payload.error,
          },
        },
      };

    case RESET_WIZARD_SUCCESS:
      return {
        ...state,
        wizards: {
          ...state.wizards,
          [wizardType]: initialWizardState,
        },
      };

    case CLEAR_WIZARD_ERROR:
      if (wizardType && state.wizards[wizardType]) {
        return {
          ...state,
          wizards: {
            ...state.wizards,
            [wizardType]: {
              ...state.wizards[wizardType],
              error: null,
            },
          },
        };
      }
      return state;

    default:
      return state;
  }
};

export default wizardReducer;
